module.exports = __webpack_public_path__ + "img/w3_check_circle_light.903f7599.png";